import { z } from "zod";

const phonePattern = /^\d*$/;

export const postMinorDependentSchema = z.object({
  givenName: z
    .string()
    .trim()
    .min(1, "Required")
    .max(250, { message: "Must be 100 or fewer characters long" }),
  dob: z.date({ message: "Required" }),
  gender: z.string().trim().min(1, "Required").max(10),
  address1: z
    .string()
    .trim()
    .min(1, "Required")
    .max(50, { message: "Must be 50 or fewer characters long" }),
  address2: z.optional(z.string()),
  city: z
    .string()
    .trim()
    .min(1, "Required")
    .max(20, { message: "Must be 20 or fewer characters long" }),
  state: z
    .string()
    .trim()
    .min(1, "Required")
    .max(10, { message: "Must be 10 or fewer characters long" }),
  zip: z
    .string()
    .trim()
    .min(1, "Required")
    .max(20, { message: "Must be 20 or fewer characters long" }),
  dialCode: z.any(),
  primaryPhone: z.string().trim().min(1, "Required").regex(phonePattern, {
    message:
      'Phone must start with a "+" followed by country code and phone number (e.g., +123456789012)',
  }),
  minorRelationship: z.string().trim().min(1, "Required").max(30),
  certifiedLegalRight: z.boolean().refine((val) => val === true, {
    message: "Please certify",
  }),
  confirmReadAuthorization: z.boolean().refine((val) => val === true, {
    message: "Please confirm",
  }),
});
